var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployerBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 295,
    viewBox: "0 0 362 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362 53.5C362 83.0472 338.047 107 308.5 107C278.953 107 255 83.0472 255 53.5C255 23.9528 278.953 0 308.5 0C338.047 0 362 23.9528 362 53.5Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.5 80.25C323.274 80.25 335.25 68.2736 335.25 53.5C335.25 38.7264 323.274 26.75 308.5 26.75C293.726 26.75 281.75 38.7264 281.75 53.5C281.75 68.2736 293.726 80.25 308.5 80.25ZM308.5 107C338.047 107 362 83.0472 362 53.5C362 23.9528 338.047 0 308.5 0C278.953 0 255 23.9528 255 53.5C255 83.0472 278.953 107 308.5 107Z",
    fill: "#32A89C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88 108C88 132.301 68.3005 152 44 152C19.6995 152 0 132.301 0 108C0 83.6995 19.6995 64 44 64C68.3005 64 88 83.6995 88 108Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 130C56.1503 130 66 120.15 66 108C66 95.8497 56.1503 86 44 86C31.8497 86 22 95.8497 22 108C22 120.15 31.8497 130 44 130ZM44 152C68.3005 152 88 132.301 88 108C88 83.6995 68.3005 64 44 64C19.6995 64 0 83.6995 0 108C0 132.301 19.6995 152 44 152Z",
    fill: "#32A89C"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362 255C362 274.33 346.33 290 327 290C307.67 290 292 274.33 292 255C292 235.67 307.67 220 327 220C346.33 220 362 235.67 362 255Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327 272.5C336.665 272.5 344.5 264.665 344.5 255C344.5 245.335 336.665 237.5 327 237.5C317.335 237.5 309.5 245.335 309.5 255C309.5 264.665 317.335 272.5 327 272.5ZM327 290C346.33 290 362 274.33 362 255C362 235.67 346.33 220 327 220C307.67 220 292 235.67 292 255C292 274.33 307.67 290 327 290Z",
    fill: "#32A89C"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174 264C174 281.121 160.121 295 143 295C125.879 295 112 281.121 112 264C112 246.879 125.879 233 143 233C160.121 233 174 246.879 174 264Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143 279.5C151.56 279.5 158.5 272.56 158.5 264C158.5 255.44 151.56 248.5 143 248.5C134.44 248.5 127.5 255.44 127.5 264C127.5 272.56 134.44 279.5 143 279.5ZM143 295C160.121 295 174 281.121 174 264C174 246.879 160.121 233 143 233C125.879 233 112 246.879 112 264C112 281.121 125.879 295 143 295Z",
    fill: "#32A89C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployerBackground);
export default __webpack_public_path__ + "static/media/Employer-background.4e7b8eaf57417d6ee73aff5eb4cf2b9b.svg";
export { ForwardRef as ReactComponent };